import { render, staticRenderFns } from "./SettingsWheel.vue?vue&type=template&id=f8f7c488"
import script from "./SettingsWheel.vue?vue&type=script&lang=js"
export * from "./SettingsWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports